import React from 'react';

export default () => (
  <svg width="57" height="57" viewBox="0 0 57 57" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="a">
        <stop stopColor="#7EC1F3" stopOpacity="0" offset="0%" />
        <stop stopColor="#E4F1FD" offset="100%" />
      </linearGradient>
    </defs>
    <g fillRule="nonzero" transform="translate(-363 -783)" fill="url(#a)" opacity=".746">
      <path opacity=".323" d="M407.269 819.824L375 839l41.782-2.838L420 794l-12.731 25.824z" />
      <path
        opacity=".323"
        d="M416 837l-3.491-25L403 825.028 416 837zM417 837.118L390.539 835 375 840z"
      />
      <path opacity=".323" d="M375.183 840L382 818l-15 3.16 8.183 18.84z" />
      <path opacity=".323" d="M404 825l-6.215-24L380 817.436 404 825z" />
      <path
        opacity=".323"
        d="M419 801.608L402.574 788 398 803l21-1.392zM411 783.066L401.19 788l-6.19-5 16 .066zM363 828l4-7.301-3.236-8.699z"
      />
      <path
        d="M364 811.699l3.332 9.301 14.476-3.197 16.528-15.118L403 788.104 395.656 783l-12.486 4.6c-3.935 3.6-11.568 10.726-11.843 10.86-.273.137-5.041 9.008-7.327 13.239z"
        opacity=".323"
      />
      <path
        d="M375.096 794.569c8.379-8.319 19.18-13.234 23.324-9.046 4.142 4.188-.25 14.365-8.629 22.681-8.378 8.316-19.044 13.502-23.187 9.314-4.144-4.185.114-14.633 8.492-22.95zM375 840l6.48-22 21.52 7.086c-7.78 7.479-16.435 13.801-28 14.914zM398 802.43l5.6 22.57c6.59-7.049 12.504-14.627 15.4-24l-21 1.43zM418.665 801c2.266-6.664 2.79-16.225-7.897-18L402 787.72 418.665 801zM363 828.268c.316 11.46 8.51 11.632 12 11.732l-8.062-19-3.938 7.268z"
        opacity=".323"
      />
      <path
        d="M398 802.405c5.112 3.15 15.415 9.475 15.624 9.592.325.183 4.442-6.96 5.376-10.997l-21 1.405zM381 818l8.877 17c5.248-2.826 9.359-6.268 13.123-9.956L381 818zM367.249 821.004l-.624 7.356c-.14 1.635-.347 4.088-.625 7.357 2.357 3.185 5.6 3.462 9 3.214-2.46-6.059-7.376-18.173-7.751-17.927zM402 787.648L419 790c-.907-3.79-3.694-6.235-8.443-7L402 787.648z"
        opacity=".323"
      />
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/ruby.es6.js